import React from 'react';

import { themeClassName } from 'yeself-common/ModelUtils';
import { SHADOW_TYPE } from 'yeself-common/ModelConstant';

const BubblePreview = ({ themeId }) => (
    <div
        className={`${themeClassName('shadow', themeId)} ${themeClassName(
            `shadow-${SHADOW_TYPE.TRANSPARENT}`,
            themeId
        )}`}
        style={{ position: 'relative', width: '100%', height: 220 }}
    >
        <div
            className={themeClassName('bubble-container', themeId)}
            style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}
        >
            <div className={themeClassName('bubble', themeId)}>
                <div className={themeClassName('bubble-header', themeId)}>
                    <button className={themeClassName('bubble-close', themeId)} type="button">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 50 50"
                            width="14"
                            height="14"
                        >
                            <g id="surface1">
                                <path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z " />
                            </g>
                        </svg>
                    </button>
                </div>
                <div className={themeClassName('bubble-body', themeId)}>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: '<h2>My new step 1</h2><p>Place your description here</p>',
                        }}
                    />
                </div>
                <div className={themeClassName('bubble-footer', themeId)}>
                    <div className={themeClassName('bubble-index', themeId)}>
                        <span className={themeClassName('bubble-counter', themeId)}>Step 1</span>
                    </div>
                    <div className={themeClassName('bubble-navigation', themeId)}>
                        <button type="button" className={themeClassName('bubble-previous', themeId)}>
                            Back
                        </button>
                        <button type="button" className={themeClassName('bubble-next', themeId)}>
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default BubblePreview;
